<template>
    <div class="overflow-x-hidden">
        <section
            class="community-section grid flex flex-wrap justify-content-center align-items-center my-4 md:px-8 ">
            <div class="card-container relative border-round-3xl overflow-hidden shadow-4 col-11 md:py-8">
                <div class="background-image"
                    :style="{ backgroundImage: `url('${bgUrl}')`,  filter: 'blur(2px) brightness(0.6)', zIndex: 0 }">
                </div>
                <div class="relative z-1 text-center md:px-4 md:px-8 py-6">
                    <span v-if="label" class="badge inline-block mb-3 text-sm font-medium px-3 py-1">
                        Join Community
                    </span>
                    <h2 class="H5-SemiBold mb-2 text-white">{{ title || "" }}</h2>
                    <p class="text-white/90 mb-5 md:px-8 Paragraph-Regular text-white">
                        {{ description || "" }}
                    </p>
                    <Button v-if="label" :label=label icon="pi pi-arrow-right" iconPos="right" class="community-button" @click="navigatePages"/>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import Button from 'primevue/button';
import { usePublicUrl } from "@/utils/getPublicUrl"
import { useRouter } from "vue-router";

const props = defineProps({
    title: String,
    description: String,
    label: String,
    imageUrl: null

});
const router = useRouter();
const bgUrl = usePublicUrl(props?.imageUrl);
const navigatePages = () =>{
router.push('/onBoarding')
}
</script>

<style scoped>
.background-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}
</style>